<template>
  <div v-if="renderTask" class="o-taskitem" :class="[`state-${state.type}`]">
    <div class="taskitem__task">
      <div class="task__items">
        <div class="items__content content--icon">
          <font-awesome-icon
            v-if="hasIcon"
            :icon="state.icon"
            transform="shrink-6"
            mask="circle"
            :color="state.iconcolor"
          />
        </div>
        <div class="items__content content--date" v-if="hasDate">
          {{ $d(new Date(taskItem.period.end || taskItem.period.start), 'L') }}
        </div>
        <div class="items__content content--name" v-if="hasName">
          <a
            class="titleLink"
            v-if="((hasExternalLink || hasKatalogLink || hasFileuploadLink ) && !isInsurance) || deeplink !== undefined"
            @click.prevent="
              setStepHistory(
                getUrl(),
                hasExternalLink && !isInsurance && task.manualdeeplinktargetblank ? true : false
              )
            "
          >
            {{ taskItem.displayName }}
          </a>
          <a
            class="titleLink"
            v-else-if="isInsurance"
            href="#"
            @click.prevent="setStepHistory(null)"
          >
            {{ taskItem.displayName }}
          </a>
          <span v-else>
            {{ taskItem.displayName }}
          </span>
        </div>
      </div>

      <div
        class="task__items task__items2"
        v-if="
          hasNotification ||
            hasExternalLink ||
             hasKatalogLink || hasFileuploadLink ||
            isInsurance ||
            deeplink !== undefined
        "
      >
        <div
          class="items__content content--notification"
          v-if="hasNotification"
        >
          <switcher
            :state="
              taskItem.notificationState === undefined
                ? false
                : !taskItem.notificationState
            "
            :textOn="$t('components.taskItem.notification.on')"
            :textOff="$t('components.taskItem.notification.off')"
            @switcherChange="changeState"
          />
        </div>
      </div>
    </div>
    <div class="taskitem__infotext" v-if="hasInfo">
      <p v-for="(text, index) in info" :key="index">{{ text }}</p>
    </div>
    <div
      class="taskitem__infotext"
      v-if="task.costs !== undefined && task.costs.length > 0"
    >
      <button class="section-toggler" v-b-toggle="taskItem._id">
        <font-awesome-icon class="toggler-icon__expand" icon="minus" />
        <font-awesome-icon class="toggler-icon__collapse" icon="plus" />
        {{ $t('components.costListing.table.costs.head.article') }}
      </button>

      <!-- Write <b-collapse accordion="costAccordion"> to allow only one open collapse at the moment -->
      <b-collapse class="section-tab" :id="taskItem._id">
        <b-table
          :items="task.costs"
          :fields="[
            {
              key: 'article',
              label: $t('components.costListing.table.costs.head.article'),
              class: 'col-article'
            },
            {
              key: 'description',
              label: $t('components.costListing.table.costs.head.description'),
              class: 'col-description'
            },
            {
              key: 'amount',
              label: $t('components.costListing.table.costs.head.amount'),
              class: 'col-amount'
            },
            {
              key: 'cost',
              label: $t('components.costListing.table.costs.head.cost'),
              class: 'col-cost'
            },
            {
              key: 'total',
              label: $t('components.costListing.table.costs.head.total'),
              class: 'col-total'
            }
          ]"
          responsive
        ></b-table>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import ApiService from '@/services/ApiService'
import Switcher from '@/components/Switcher'
import { VBToggle, BCollapse, BTable } from 'bootstrap-vue'
import { filter } from 'lodash'

Vue.directive('b-toggle', VBToggle)

export default {
  name: 'TaskItem',
  props: {
    task: {
      type: Object,
      required: true,
      default: () => ({})
    },
    isCoexposant: Boolean,
    startLoadingShopLinks: {
      type: Boolean,
      default: true
    },
    shopLinks: {
      type: Array,
      required: true,
      default: () => []
    },
    booth: String,
    renderCondition: {
      type: String,
      default: 'all'
    },
    link: null,
    linkParams: {},
    serviceShopId: String
  },
  data() {
    return {
      isDone: false,
      now: new Date().getTime(),
      taskRenderCondition: this.renderCondition,
      taskItem: this.task,
      states: [
        {
          type: 'done',
          icon: 'check',
          iconcolor: '#BBA868',
          externalIcon: 'eye',
          trigger: task =>
            this.isDone || task.isDone || task.notificationState === false,
          val: 30
        },
        {
          type: 'unknown',
          icon: 'question',
          iconcolor: '#BBA868',
          trigger: task =>
            !(task.period && task.period.start && task.period.end),
          val: 100
        },
        {
          type: 'overdue',
          externalIcon: 'eye',
          icon: 'times',
          iconcolor: '#BBA868',
          trigger: task => this.now > this.endTime,
          val: 90
        },
        {
          type: 'inactive',
          externalIcon: 'eye',
          icon: 'minus',
          iconcolor: '#BBA868',
          trigger: task =>
            this.now < this.startTime || (!task.required && task.isDisabled),
          val: 40
        },
        /*
        {
          type: 'due',
          externalIcon: 'pen',
          icon: 'exclamation',
          iconcolor: '#BBA868',
          trigger: task => this.now > this.endTime - 5 * 24 * 60 * 60 * 1000,
          val: 10
        },
        */
        {
          type: 'pendent',
          externalIcon: 'pen',
          icon: 'hourglass-half',
          iconcolor: '#BBA868',
          trigger: task => this.now >= this.startTime,
          val: 20
        }
      ],
      notificationStates: ['insurance', 'due', 'pendent', 'done'],
      deeplink: undefined,
      boothInfo: {}
    }
  },
  computed: {
    startTime() {
      let startDate = new Date((this.taskItem.period || {}).start || 0)

      startDate.setUTCHours(0)
      startDate.setUTCMinutes(0)
      startDate.setUTCSeconds(0)
      startDate.setUTCMilliseconds(0)

      return startDate.getTime()
    },
    endTime() {
      let endTime = new Date((this.taskItem.period || {}).end || this.now)

      endTime.setUTCHours(23)
      endTime.setUTCMinutes(59)
      endTime.setUTCSeconds(59)
      endTime.setUTCMilliseconds(999)

      return endTime.getTime()
    },
    publishStartTime() {
      let startDate = new Date((this.taskItem.published || {}).start || 0)

      startDate.setUTCHours(0)
      startDate.setUTCMinutes(0)
      startDate.setUTCSeconds(0)
      startDate.setUTCMilliseconds(0)

      return startDate.getTime()
    },
    publishEndTime() {
      let endTime = new Date((this.taskItem.published || {}).end || this.now)

      endTime.setUTCHours(23)
      endTime.setUTCMinutes(59)
      endTime.setUTCSeconds(59)
      endTime.setUTCMilliseconds(999)

      return endTime.getTime()
    },
    isTitle() {
      return this.state.type === 'title'
    },
    isInsurance() {
      return (
        this.taskItem.serviceGroup !== undefined &&
        this.taskItem.serviceGroup.toLowerCase() === 'vers'
      )
    },
    hasIcon() {
      return this.state.icon !== undefined
    },
    hasDate() {
      return (
        this.taskItem.period &&
        (
          (
            this.taskItem.period.start !== undefined &&
            this.taskItem.period.start !== null
          ) || (
            this.taskItem.period.end !== undefined &&
            this.taskItem.period.end !== null
          )
        )
      )
    },
    hasName() {
      return (
        this.taskItem.displayName !== undefined &&
        this.taskItem.displayName !== null
      )
    },
    hasInfo() {
      return this.info.length > 0
    },
    hasNotification() {
      return (
        this.taskItem.required !== true &&
        this.notificationStates.includes(this.state.type) &&
        !this.taskItem.isDone
      )
    },
    hasExternalLink() {
      return this.task.deeplinkmode === 'manual' && this.task.url !== undefined && this.task.url !== null
    },
    state() {
      return this.states.find(state => state.trigger(this.taskItem))
    },
    info() {
      return this.taskItem.infoTexts
        .filter(
          info =>
            (info.publish === undefined) ||
            (
              (info.publish.start === undefined || info.publish.start === null || new Date(info.publish.start).getTime() <= this.now) &&
              (info.publish.end === undefined || info.publish.end === null || new Date(info.publish.end).getTime() >= this.now)
            )
        )
        .map(info => info.text)
    },
    renderTask() {
      let linkAvailable =
        this.deeplink !== undefined ||
        this.isInsurance ||
        this.task.deeplinkmode === 'manual' || this.hasKatalogLink || this.hasFileuploadLink
      return (
        (this.taskRenderCondition === 'all' ||
          this.state.type === this.taskRenderCondition) &&
        linkAvailable &&
        (!this.isCoexposant ||
          this.task.coexposant === true ||
          (this.task.deeplinkmode !== 'manual'))
      )
    },
    hasKatalogLink() {
      return this.task.deeplinkmode === 'katalog' && this.getKatalogLink !== null;
    },
    hasFileuploadLink() {
      return this.task.deeplinkmode === 'fileupload' && this.getFileuploadLink !== null;
    },
    getKatalogLink() {
      let links = this.shopLinks.map((item) => item.shopLinks.filter((item2) => item2.ziel === 'KATALOG') ).filter((item) => item.length > 0).reverse();
      if (links.length > 0) {
        return links[0][0].href;
      }
      return null
    },
    getFileuploadLink() {
      let links = this.shopLinks.map((item) => item.shopLinks.filter((item2) => item2.ziel === 'FILEUPLOAD') ).filter((item) => item.length > 0).reverse();
      if (links.length > 0) {
        return links[0][0].href;
      }
      return null
    }
  },
  methods: {
    getUrl() {
      if (!this.isInsurance) {
        if (this.hasExternalLink) {
          return this.task.url;
        }
        if (this.hasKatalogLink) {
          return this.getKatalogLink
        }
        if (this.hasFileuploadLink) {
          return this.getFileuploadLink
        }
      }
      return this.deeplink.href;
    },
    setStepHistory(url, newwindow) {
      // Get booth info without using getters.
      const booth = filter(this.$store.state.fair.booths, {
        regiNr: this.$route.params.booth
      })

      let halleBezeichnung = '';

      if (booth && booth.length > 0) {
        halleBezeichnung = booth[0].halleBezeichnungDe
        if (this.$store.state.ui.i18n.locale === 'fr-CH') {
          halleBezeichnung = booth[0].halleBezeichnungFr
        }
        if (this.$store.state.ui.i18n.locale === 'en-US') {
          halleBezeichnung = booth[0].halleBezeichnungEn
        }
      }

      ApiService.setCurrentStep(
        this.booth,
        this.taskItem.serviceGroup,
        booth[0].standnummer,
        halleBezeichnung,
        this.$route.params.code
      )

      if (url === null) {
        this.goToInsurance()
        return
      }

      const fullUrl = url +
        '?' +
        this.parsedParams(
          Object.assign(this.linkParams, {
            language: this.$store.getters['ui/getLooseLocale'],
            'regi-nr': this.booth,
            'service-group': this.taskItem.serviceGroup
          })
        )

      if (newwindow === true) {
        window.open(fullUrl, '_blank')
      } else {
        window.location.href = fullUrl
      }
    },
    parsedParams(data) {
      let retVal = []
      for (let key in data) {
        retVal.push(encodeURI(key) + '=' + encodeURI(data[key]))
      }
      return retVal.join('&')
    },
    changeState(notificationState) {
      let inverseState = !notificationState 
      ApiService.updateTaskNotificationState({
        id: this.taskItem._id,
        booth: this.booth,
        notificationState: inverseState
      }).then(response => {
        this.$set(
          this.taskItem,
          'notificationState',
          response.data.notificationState
        )
        this.$store.dispatch('fair/updateBoothNotificationState', [
          this.booth,
          this.taskItem._id,
          inverseState
        ])
        this.$emit('updateGroup')
      })
      this.$emit('updateGroup')
    },
    goToInsurance() {
      this.$router.push({
        name: 'Insurance'
      })
    },
    checkServiceShopLinks() {
      if (
        this.startLoadingShopLinks &&
        this.taskItem.serviceGroup !== undefined &&
        this.taskItem.serviceGroup.toLowerCase() !== 'vers' &&
        (this.task.deeplinkmode !== 'manual' || this.task.url !== undefined) &&
        this.link === undefined &&
        this.serviceShopId !== null
      ) {
        const promise = new Promise((resolve, reject) => {
          const lang = this.$store.getters['ui/getLocale']
          ApiService.getRubinServiceShopLink(
            this.$route.params.booth,
            this.serviceShopId,
            this.task.serviceGroup,
            lang.toLowerCase().substr(0, 2)
          ).then(
            result => {
              this.deeplink = result.data[0]
              this.$emit('updateGroup')
              resolve()
            },
            err => {
              console.log(err)
              resolve()
            }
          )
        })
      } else if (
        this.taskItem.serviceGroup !== undefined &&
        this.taskItem.serviceGroup.toLowerCase() !== 'vers'
      ) {
        this.$emit('updateGroup')
      }
    }
  },
  watch: {
    '$props.task'(newTask) {
      this.taskItem = newTask
    },
    '$props.renderCondition'(newRenderCondition) {
      this.taskRenderCondition = newRenderCondition
    },
    '$props.startLoadingShopLinks'() {
      this.checkServiceShopLinks()
    },
    'this.$route.params.booth'(newBooth) {
      this.checkServiceShopLinks()
    },
    '$props.serviceShopId'(newServiceShopId) {
      this.checkServiceShopLinks()
    }
  },
  created() {
    this.$store.subscribe((mutation, state) => {
      switch (mutation.type) {
        case 'fair/setBoothInsurance':
          if (
            this.taskItem.serviceGroup !== undefined &&
            this.taskItem.serviceGroup.toLowerCase() === 'vers' &&
            this.$store.getters['fair/getBoothInsurance'](this.$route.params.booth)
              .data !== undefined &&
            this.$store.getters['fair/getBoothInsurance'](this.$route.params.booth)
              .data.length > 0
          ) {
            this.taskItem.isDone = true
            this.isDone = true;
            this.$emit('updateGroup')
          }
          break;
      }
    });
  },
  mounted() {
    this.checkServiceShopLinks()

    this.boothInfo = this.$store.getters['fair/getBooth'](
      this.$route.params.booth
    )

    if (
      this.taskItem.serviceGroup !== undefined &&
      this.taskItem.serviceGroup.toLowerCase() === 'vers' &&
      this.$store.getters['fair/getBoothInsurance'](this.$route.params.booth)
        .data !== undefined &&
      this.$store.getters['fair/getBoothInsurance'](this.$route.params.booth)
        .data.length > 0
    ) {
      this.taskItem.isDone = true
      this.isDone = true;
    }

    this.$emit('updateGroup')

    if (
      !this.taskItem.isDone &&
      this.taskItem.serviceGroup !== undefined &&
      this.taskItem.serviceGroup.toLowerCase() !== 'vers'
    ) {
      new Promise((resolve, reject) => {
        ApiService.getRubinOrderExisting(
          this.$route.params.booth,
          this.taskItem.serviceGroup
        ).then(
          result => {
            this.taskItem.isDone = this.taskItem.isDone || result.data.vorhanden
            this.isDone = result.data.vorhanden
            this.$emit('updateGroup')
            resolve()
          },
          err => {
            console.log(err)
            resolve()
          }
        )
      })
    }
  },
  components: {
    Switcher,
    BTable,
    BCollapse
  }
}
</script>

<style lang="scss">
@import '@/assets/css/variables.scss';

$taskitem-task-padding-y: 0.4em !default;
$taskitem-task-padding-x: 2em !default;

$taskitem-task-padding-x-sm: 2em !default;

$taskitem-task-title-margin: 0 !default;
$taskitem-task-title-font-size: null !default;
$taskitem-task-title-font-weight: null !default;
$taskitem-task-title-color: null !default;

$taskitem-task-attention-size: 1.6em !default;
$taskitem-task-attention-bg: $brand-white !default;
$taskitem-task-attention-color: $brand-red !default;
$taskitem-task-attention-box-shadow: 0 0 4px 0 rgba($brand-black, 0.33) !default;

$taskitem-task-content-gap: $grid-gutter * 2 !default;

$taskitem-task-content-icon-min-width: 2.5em !default;
$taskitem-task-content-icon-height: 1.6em !default;

$taskitem-task-content-date-min-width: $taskitem-task-content-icon-min-width !default;
$taskitem-task-content-date-font-size: inherit !default;
$taskitem-task-content-date-font-weight: inherit !default;

$taskitem-task-content-name-font-size: inherit !default;
$taskitem-task-content-name-font-weight: $font-weight-normal !default;

$taskitem-task-content-notification-font-size: $taskitem-task-content-date-font-size !default;
$taskitem-task-content-notification-font-weight: $taskitem-task-content-date-font-weight !default;

$taskitem-task-content-link-font-size: 1.1em !default;
$taskitem-task-content-link-font-weight: $taskitem-task-content-date-font-weight !default;

$taskitem-infotext-padding: 1em $taskitem-task-padding-x 1em 4.5em !default;
$taskitem-infotext-bg: white !default;
$taskitem-infotext-font-size: 0.9em !default;
$taskitem-infotext-font-weight: inherit !default;
$taskitem-infotext-color: inherit !default;
$taskitem-infotext-box-shadow: none !default;
$taskitem-infotext-info-gap: 0.5em !default;

$taskitem-task-state-unknown-bg: $brand-gray !default;
$taskitem-task-state-unknown-color: $brand-white !default;

$taskitem-task-state-insurance-bg: $brand-blue !default;
$taskitem-task-state-insurance-color: $brand-white !default;

$taskitem-task-state-inactive-bg: $brand-olive !default;
$taskitem-task-state-inactive-color: $brand-white !default;

$taskitem-task-state-pendent-bg: $brand-blue !default;
$taskitem-task-state-pendent-color: $brand-white !default;

$taskitem-task-state-due-bg: $taskitem-task-state-pendent-bg !default;
$taskitem-task-state-due-color: $brand-white !default;

$taskitem-task-state-overdue-bg: $brand-red !default;
$taskitem-task-state-overdue-color: $brand-white !default;

$taskitem-task-state-done-bg: $brand-turquoise !default;
$taskitem-task-state-done-color: $brand-white !default;

$taskitem-task-state-title-bg: transparent !default;
$taskitem-task-state-title-color: $brand-darkgray !default;
$taskitem-task-state-title-text-align: left !default;

$taskitem-accordion-section-toggler-padding: 0.6em 10px !default;
$taskitem-accordion-section-toggler-font-family: inherit !default;
$taskitem-accordion-section-toggler-font-size: inherit !default;
$taskitem-accordion-section-toggler-font-weight: $font-weight-bold !default;
$taskitem-accordion-section-toggler-color: inherit !default;
$taskitem-accordion-section-toggler-icon-gap: 0.5em !default;
$taskitem-accordion-section-toggler-icon-size: 1em !default;
$taskitem-accordion-section-toggler-icon-color: $brand-blue !default;

$taskitem-accordion-section-open-toggler-font-family: $taskitem-accordion-section-toggler-font-family !default;
$taskitem-accordion-section-open-toggler-font-size: $taskitem-accordion-section-toggler-font-size !default;
$taskitem-accordion-section-open-toggler-font-weight: $taskitem-accordion-section-toggler-font-weight !default;
$taskitem-accordion-section-open-toggler-color: $brand-blue !default;
$taskitem-accordion-section-open-toggler-icon-gap: 0.5em !default;
$taskitem-accordion-section-open-toggler-icon-size: 1em !default;
$taskitem-accordion-section-open-toggler-icon-color: $brand-blue !default;

$taskitem-accordion-section-tab-padding: 0 0 4.5rem 1.5em !default;
$taskitem-accordion-section-tab-transition: all 200ms ease-out !default;

$taskitem-table-border: 1px solid lighten($brand-gray, 25%) !default;

.o-taskitem {
  position: relative;

  .taskitem__task {
    display: flex;
    justify-content: space-between;
    background-color: #fbfbfb;
    position: relative;
    padding: $taskitem-task-padding-y 1.5em $taskitem-task-padding-y
      $taskitem-task-padding-x;

    line-height: 1;

    .task__title {
      margin: $taskitem-task-title-margin;
      font-size: $taskitem-task-title-font-size;
      font-weight: $taskitem-task-title-font-weight;
      color: $taskitem-task-title-color;
    }

    .task__attention {
      display: none;
      position: absolute;
      bottom: 100%;
      left: $taskitem-task-padding-x;
      width: $taskitem-task-attention-size;
      height: $taskitem-task-attention-size;
      background-color: $taskitem-task-attention-bg;
      color: $taskitem-task-attention-color;
      border-radius: 50%;
      box-shadow: $taskitem-task-attention-box-shadow;
      transform: translateY(50%);

      .attention__icon {
        display: block;
        margin: -1px;
        width: calc(100% + 2px);
        height: calc(100% + 2px);
        font-size: $taskitem-task-attention-size;
      }
    }

    .task__items {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-left: $taskitem-task-content-gap * -0.5;
      margin-right: $taskitem-task-content-gap * -0.5;

      .items__content {
        padding-left: $taskitem-task-content-gap * 0.5;
        padding-right: $taskitem-task-content-gap * 0.5;

        &.content--icon {
          min-width: $taskitem-task-content-icon-min-width;
          height: $taskitem-task-content-icon-height;
          padding-left: 8px;
          padding-right: 10px;
          font-size: 1.6em;
          color: inherit;
          padding-top: 8px;
        }

        &.content--date {
          min-width: 6.2em;
          font-size: $taskitem-task-content-date-font-size;
          font-weight: $taskitem-task-content-date-font-weight;
        }

        &.content--name {
          font-size: $taskitem-task-content-name-font-size;
          font-weight: $taskitem-task-content-name-font-weight;

          .titleLink {
            color: inherit;
            text-decoration: none;
            transition: none;

            &:hover {
              color: $brand-primary;
            }
          }
        }

        &.content--notification {
          font-size: $taskitem-task-content-notification-font-size;
          font-weight: $taskitem-task-content-notification-font-weight;
        }

        &.content--link {
          font-size: $taskitem-task-content-link-font-size;
          font-weight: $taskitem-task-content-link-font-weight;

          a {
            color: inherit;
            text-decoration: none;
          }
        }
      }
    }
  }

  .taskitem__infotext {
    padding: $taskitem-infotext-padding;
    background-color: $taskitem-infotext-bg;
    font-size: $taskitem-infotext-font-size;
    font-weight: $taskitem-infotext-font-weight;
    color: $taskitem-infotext-color;
    box-shadow: $taskitem-infotext-box-shadow;

    .sm &,
    .xs & {
      padding: 1em 2.2em;
    }

    p {
      margin: $taskitem-infotext-info-gap 0 0;

      &:first-child {
        margin: 0;
      }
    }
  }

  &.state-due {
    .taskitem__task {
      .task__attention {
        display: block;
      }
    }
  }

  &.state-title {
    .taskitem__task {
      display: block;
      overflow: hidden;
      padding-left: 0;
      padding-right: 0;
      padding-bottom: 0;
      background-color: $taskitem-task-state-title-bg;
      color: $taskitem-task-state-title-color;
      text-align: $taskitem-task-state-title-text-align;
      line-height: 1.5;
    }
  }

  .centered {
    text-align: center;
  }

  @media screen {
    .md &,
    .sm &,
    .xs & {
      .taskitem__task {
        //        display: block;

        .task__items {
          + .task__items {
            margin-top: $taskitem-task-content-gap;
          }
        }
      }
    }

    .sm &,
    .xs & {
      .taskitem__task {
        .task__items {
          display: block;

          .items__content {
            + .items__content {
              margin-top: $taskitem-task-content-gap * 0.5;
            }
          }
        }

        .task__items2 {
          display: flex;
        }
      }
    }
  }

  .section-toggler {
    display: block;
    padding: $taskitem-accordion-section-toggler-padding;
    width: 100%;
    background: none;
    border: 0 none;
    font-family: $taskitem-accordion-section-toggler-font-family;
    font-size: $taskitem-accordion-section-toggler-font-size;
    font-weight: $taskitem-accordion-section-toggler-font-weight;
    color: $taskitem-accordion-section-toggler-icon-color !important;
    text-align: left;
    line-height: 19px;

    svg {
      margin-right: $taskitem-accordion-section-toggler-icon-gap;
      width: $taskitem-accordion-section-toggler-icon-size;
      height: $taskitem-accordion-section-toggler-icon-size;
      color: $taskitem-accordion-section-toggler-icon-color !important;
    }

    &:hover {
      //      background-color: #f7f6f3;
    }

    &[aria-expanded='false'] {
      svg {
        &.toggler-icon__expand {
          display: none;
        }
      }
    }

    &[aria-expanded='true'] {
      font-family: $taskitem-accordion-section-open-toggler-font-family;
      font-size: $taskitem-accordion-section-open-toggler-font-size;
      font-weight: $taskitem-accordion-section-open-toggler-font-weight;
      color: $taskitem-accordion-section-open-toggler-color;

      svg {
        margin-right: $taskitem-accordion-section-open-toggler-icon-gap;
        width: $taskitem-accordion-section-open-toggler-icon-size;
        height: $taskitem-accordion-section-open-toggler-icon-size;
        color: $taskitem-accordion-section-open-toggler-icon-color;

        &.toggler-icon__collapse {
          display: none;
        }
      }
    }
  }

  .section-tab {
    overflow: hidden;
    transition: $taskitem-accordion-section-tab-transition;

    table {
      th,
      td {
        width: 100%;
        border-top: $taskitem-table-border;
        border-bottom: $taskitem-table-border;
        text-align: left;

        &.col-article,
        &.col-amount,
        &.col-cost,
        &.col-total {
          width: 0%;
          white-space: nowrap;
        }

        &.col-amount,
        &.col-cost,
        &.col-total,
        &.col-totaltext,
        &.col-currency,
        &.col-summary {
          text-align: right;
        }
      }
    }
  }

  @media print {
    .taskitem__task {
      .o-switcher {
        .switcher-wrapper {
          border-color: #000;

          .switcher-handle {
            border: 4px solid #000;
          }
        }
      }
    }

    &.state-unknown {
      .taskitem__task {
        border: 2px solid $taskitem-task-state-unknown-bg;
      }
    }

    &.state-insurance {
      .taskitem__task {
        border: 2px solid $taskitem-task-state-insurance-bg;
      }
    }

    &.state-inactive {
      .taskitem__task {
        border: 2px solid $taskitem-task-state-inactive-bg;
      }
    }

    &.state-pendent {
      .taskitem__task {
        border: 2px solid $taskitem-task-state-pendent-bg;
      }
    }

    &.state-due {
      .taskitem__task {
        border: 2px solid $taskitem-task-state-due-bg;
      }
    }

    &.state-overdue {
      .taskitem__task {
        border: 2px solid $taskitem-task-state-overdue-bg;
      }
    }

    &.state-done {
      .taskitem__task {
        border: 2px solid $taskitem-task-state-done-bg;
      }
    }
  }
}
</style>
